import { array, func, number, string, object } from 'prop-types'
import Conditional from '../Conditional'
import Pill from '../Pill'
import StatusDot from '../StatusDot'
import { kuiperClassNames, renderIcon } from '../utils'

const getIEVersion = () => {
  const userAgent = window.navigator.userAgent
  const index = userAgent.indexOf('MSIE')
  let version = 0

  if (index >= 0) {
    version = parseInt(
      userAgent.substring(index + 5, userAgent.indexOf('.', index)),
      10
    )
  } else if (navigator.userAgent.match(/Trident\/7\./)) {
    version = 11
  } else if (navigator.userAgent.match(/Edge/)) {
    version = 12
  }

  return version
}

const scrollTo = (element) => {
  if (getIEVersion() > 0) {
    const parentElement = element.parentElement.parentElement
    parentElement.scrollTop = element.offsetTop
    return
  }

  element.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const mapChildren = (
  children,
  activeSection,
  sectionElements,
  setActiveSection,
  doTracking
) =>
  children.map((child, index) => {
    if (!child) return null
    return (
      <button
        key={index}
        type="button"
        className={kuiperClassNames({ active: activeSection === index })}
        onClick={() => {
          scrollTo(sectionElements[index])
          setActiveSection(index)
          doTracking('click', { Section: child.props.title })
        }}
      >
        <div>
          <span>{child.props.title}</span>
          <Conditional condition={child.props.sidebarStatusDotPresent}>
            <StatusDot status={child.props.sidebarStatusDotStatus} />
          </Conditional>
        </div>
        <Conditional condition={child.props.pillContents}>
          <Pill label={child.props.pillContents} />
        </Conditional>
      </button>
    )
  })

const getSecondaryTitle = ({ title, icon, iconOptions }) => {
  if (!title && !icon) return null

  return (
    <div className={kuiperClassNames('secondary-title')}>
      {renderIcon(icon, { ...iconOptions, ariaMode: 'hidden' })}
      <h6>{title}</h6>
    </div>
  )
}

const getTitle = (title) => {
  if (!title) return null

  return <h1>{title}</h1>
}

const StepSideBar = ({
  title,
  children,
  activeSection,
  secondaryTitle,
  sectionElements,
  setActiveSection,
  doTracking,
}) => (
  <div className={kuiperClassNames('step-side-bar')}>
    {getSecondaryTitle({ ...secondaryTitle })}
    {getTitle(title)}
    {mapChildren(
      children,
      activeSection,
      sectionElements,
      setActiveSection,
      doTracking
    )}
  </div>
)

StepSideBar.propTypes = {
  activeSection: number,
  children: array,
  doTracking: func,
  secondaryTitle: object,
  sectionElements: array,
  setActiveSection: func,
  title: string,
}

export default StepSideBar
